import { AllocationTable } from './AllocationTable'
import { ClusterDriftCard } from './ClusterDriftCard'
import { TaxForecastCard } from './TaxForecastCard'
import { ComplianceCard } from './ComplianceCard'
import type { SimulationResult } from '@/types/simulation'

interface Props {
  result: SimulationResult
}

export function WhatIfOutput({ result }: Props) {
  return (
    <div className="space-y-3">
      <AllocationTable
        before={result.allocation_before}
        after={result.allocation_after}
        strategyDrift={result.strategy_drift.positions}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <ClusterDriftCard clusters={result.cluster_drift.clusters} />
        <TaxForecastCard forecast={result.tax_forecast} />
      </div>
      <ComplianceCard rules={result.compliance.rules} />
    </div>
  )
}
